<!-- Desktop/Tablet only -->
<div class="tw-hidden md:tw-block tw-pt-[0.7rem]">
    <div class="tw-pb-10 tw-mt-3" *ngIf="drafts.length == 0 && apiResponse">
        {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
    </div>
    <!-- Draft Table -->
    <ng-container *ngIf="drafts.length > 0 && apiResponse">
        <div
            class="tw-bg-white tw-shadow-sm tw-rounded-[24px] tw-border tw-border-[#6D7A873D] tw-px-4 tw-py-2 md:tw-px-6 md:tw-py-4"
        >
            <!-- Select All Row -->
            <div
                class="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-200 tw-pb-2"
            >
                <div class="tw-flex tw-items-center tw-gap-2">
                    <input
                        type="checkbox"
                        class="appearance-none checked:bg-primary-blue tw-w-[18px] tw-h-[18px]"
                        [(ngModel)]="selectAll"
                        (input)="toggleAllCheckboxes()"
                    />
                    <span
                        class="tw-font-normal tw-text-[14px] tw-text-[#00000080]"
                        >{{ "DRAFT.SELECT_ALL" | translate }}</span
                    >
                </div>
                <div class="tw-flex tw-w-[240px] tw-justify-between">
                    <span
                        class="tw-text-sm tw-font-normal tw-text-[#00000080]"
                        >{{ "DRAFT.DATE_CREATED" | translate }}</span
                    >
                    <span
                        class="tw-text-sm tw-font-normal tw-text-[#00000080] tw-mr-6"
                        >{{ "COMMON.STATUS" | translate }}</span
                    >
                </div>
            </div>

            <ng-container *ngFor="let draft of drafts">
                <!-- Draft Row -->
                <div
                    class="tw-flex tw-items-start tw-justify-between tw-py-4 tw-border-b tw-border-gray-100 tw-gap-5"
                    *ngIf="!draft.softDelete"
                >
                    <div class="tw-flex tw-items-start tw-gap-3 tw-flex-1">
                        <div
                            class="tw-basis-1/12 tw-hidden md:tw-block"
                            *ngIf="draft.selected && totalSelected() < 2"
                        >
                            <button
                                class="tw-p-[10px] delete-btn tw-rounded-full"
                                (click)="deleteDraft()"
                            >
                                <div class="tw-w-[24px] tw-h-[24px]">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="24"
                                        viewBox="0 -960 960 960"
                                        width="24"
                                    >
                                        <path
                                            d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                                            fill="#FF8819"
                                        />
                                    </svg>
                                </div>
                            </button>
                        </div>
                        <input
                            type="checkbox"
                            class="tw-mt-[2px] tw-w-[18px] tw-h-[18px] tw-min-w-[18px] tw-min-h-[18px] tw-border tw-border-[#7B7575] tw-rounded"
                            [(ngModel)]="draft.selected"
                            (input)="toggleSelection(draft)"
                        />
                        <!-- Steps Block -->
                        <div class="tw-flex tw-flex-col tw-gap-3">
                            <span
                                class="tw-font-semibold tw-text-base tw-text-[#000000CC]"
                            >
                                {{
                                    draft.productName
                                        ? draft.productName
                                        : ("DRAFT.GET_PRODUCT_RECCOMENDATIONS"
                                          | translate)
                                }}
                            </span>
                            <div
                                class="tw-bg-gray-50 tw-rounded-lg tw-px-4 tw-py-3"
                            >
                                <div
                                    class="tw-text-[13px] tw-text-[#00000080] tw-font-semibold tw-mb-2"
                                >
                                    {{ "DRAFT.LAST_COMPLETED" | translate }}:
                                    {{ "DRAFT.STEP" | translate }}
                                    {{
                                        getStepNo(draft.qType) > 2
                                            ? getStepNo(draft.qType) - 1
                                            : getStepNo(draft.qType)
                                    }}
                                </div>
                                <hr class="my-2" />
                                <ng-container
                                    *ngIf="draft.qType as currentQType"
                                >
                                    <ng-container
                                        *ngIf="
                                            getStepNo(
                                                currentQType
                                            ) as currentStepNo
                                        "
                                    >
                                        <div
                                            class="tw-flex tw-items-start tw-gap-[11px]"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let step of steps;
                                                    let last = last
                                                "
                                            >
                                                <!-- Step Block -->
                                                <div
                                                    class="tw-flex tw-items-center tw-gap-2"
                                                >
                                                    <div
                                                        class="tw-flex tw-flex-col tw-items-start"
                                                    >
                                                        <span
                                                            class="tw-text-[12px] tw-font-medium tw-mb-1"
                                                            [ngClass]="{
                                                                'tw-text-[#000000CC]':
                                                                    step.number <=
                                                                    currentStepNo,
                                                                'tw-text-[#7B757566]':
                                                                    step.number >
                                                                    currentStepNo
                                                            }"
                                                        >
                                                            {{
                                                                "DRAFT.STEP"
                                                                    | translate
                                                            }}
                                                            {{ step.number }}
                                                        </span>
                                                        <div
                                                            class="tw-flex tw-gap-[2px]"
                                                        >
                                                            <mat-icon
                                                                class="tw-text-[17px] !tw-min-h-[18px] !tw-min-w-[18px] !tw-h-[18px] !tw-w-[18px]"
                                                                [ngClass]="{
                                                                    'tw-text-[#4B6EEC]':
                                                                        step.number <=
                                                                        currentStepNo,
                                                                    'tw-text-[#FF5757]':
                                                                        step.number >
                                                                        currentStepNo
                                                                }"
                                                            >
                                                                {{
                                                                    step.number <=
                                                                    currentStepNo
                                                                        ? "check_circle_outline"
                                                                        : "error_outline"
                                                                }}
                                                            </mat-icon>
                                                            <span
                                                                class="tw-text-sm tw-font-semibold"
                                                                [ngClass]="{
                                                                    'tw-text-[#4B6EEC]':
                                                                        step.number <=
                                                                        currentStepNo,
                                                                    'tw-text-[#000000CC]':
                                                                        step.number >
                                                                        currentStepNo
                                                                }"
                                                            >
                                                                {{
                                                                    step.label
                                                                        | translate
                                                                }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Arrow (skip for last step) -->
                                                <span
                                                    *ngIf="!last"
                                                    class="tw-text-gray-400"
                                                >
                                                    <!-- <mat-icon class="mat-icon tw-scale-[0.8] tw-text-caption-gray">
            keyboard_arrow_right
          </mat-icon> -->
                                                    <svg
                                                        width="9"
                                                        height="16"
                                                        viewBox="0 0 9 16"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M1 1L8 8L1 15"
                                                            stroke="black"
                                                            stroke-opacity="0.8"
                                                            stroke-width="2"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div
                        class="tw-flex tw-w-[240px] tw-justify-between tw-items-center"
                    >
                        <div
                            class="tw-text-sm tw-text-black tw-font-normal tw-text-center"
                        >
                            <span
                                [innerHTML]="formatDate(draft.updatedDateTime)"
                            ></span>
                        </div>
                        <button
                            class="tw-text-sm tw-font-semibold tw-px-4 tw-py-1.5 tw-rounded-full hover:tw-bg-blue-200"
                            type="submit"
                            [disabled]="draft.selected"
                            [ngClass]="{
                                'tw-text-gray-600  tw-bg-gray-200':
                                    draft.selected,
                                'tw-bg-[#DDEEF6] tw-text-[#4B6EEC] ':
                                    !draft.selected
                            }"
                            (click)="
                                resume(
                                    draft.caseId,
                                    draft.qType,
                                    draft.selectedProducts,
                                    draft.productName
                                )
                            "
                        >
                            {{ "COMMON.RESUME" | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <div
        class="tw-absolute tw-top-5 md:tw-top-[300px] tw-left-0 tw-flex tw-justify-center tw-w-full"
        *ngIf="deleteDraftMsg"
    >
        <div
            class="md:tw-flex md:tw-items-center tw-px-8 tw-py-5 tw-rounded-2xl md:tw-rounded-full md:tw-text-center tw-z-50 tw-bg-[#E0F4FF] tw-text-sm md:tw-text-base tw-text-primary-blue tw-font-semibold"
        >
            <div class="tw-hidden md:tw-block">
                <mat-icon class="tw-me-3 mat-icon">check</mat-icon>
            </div>
            <div
                class="tw-text-[10px] tw-opacity-30 tw-text-primary-blue-dark tw-font-medium tw-pb-2 tw-block md:tw-hidden"
            >
                Successful
            </div>
            {{ "DRAFT.DRAFT_DELETE" | translate }}
        </div>
    </div>
</div>

<!-- Mobile only -->
<div class="tw-block md:tw-hidden tw-py-4">
    <div class="tw-pb-10" *ngIf="drafts.length == 0 && apiResponse">
        {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
    </div>
    <!-- Draft Table -->
    <ng-container *ngIf="drafts.length > 0 && apiResponse">
        <div
            class="tw-bg-white tw-shadow-sm tw-rounded-[24px] tw-border tw-border-[#6D7A873D] tw-px-4 tw-py-2 md:tw-px-6 md:tw-py-4"
        >
            <!-- Select All Row -->
            <div
                class="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-200 tw-pb-2"
            >
                <div class="tw-flex tw-items-center tw-gap-2">
                    <input
                        type="checkbox"
                        class="appearance-none checked:bg-primary-blue tw-w-[18px] tw-h-[18px]"
                        [(ngModel)]="selectAll"
                        (input)="toggleAllCheckboxes()"
                    />
                    <span
                        class="tw-font-normal tw-text-[14px] tw-text-[#00000080] tw-w-[80px]"
                        >{{ "DRAFT.SELECT_ALL" | translate }}</span
                    >
                </div>
                <div class="tw-flex tw-w-[240px] tw-justify-between">
                    <span
                        class="tw-text-sm tw-font-normal tw-text-[#00000080]"
                        >{{ "DRAFT.DATE_CREATED" | translate }}</span
                    >
                    <span
                        class="tw-text-sm tw-font-normal tw-text-[#00000080] tw-mr-6"
                        >{{ "COMMON.STATUS" | translate }}</span
                    >
                </div>
            </div>

            <ng-container *ngFor="let draft of drafts">
                <!-- Draft Row -->
                <div
                    class="tw-py-4 tw-border-b tw-border-gray-100 tw-gap-5"
                    *ngIf="!draft.softDelete"
                >
                    <div class="tw-flex">
                        <div class="tw-flex tw-items-start tw-gap-3 tw-flex-1">
                            <div
                                class="tw-basis-1/12 tw-block"
                                *ngIf="draft.selected && totalSelected() < 2"
                            >
                                <button
                                    class="tw-p-[10px] delete-btn tw-rounded-full"
                                    (click)="deleteDraft()"
                                >
                                    <div class="tw-w-[24px] tw-h-[24px]">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 -960 960 960"
                                            width="24"
                                        >
                                            <path
                                                d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                                                fill="#FF8819"
                                            />
                                        </svg>
                                    </div>
                                </button>
                            </div>
                            <input
                                type="checkbox"
                                class="tw-mt-[2px] tw-w-[18px] tw-h-[18px] tw-min-w-[18px] tw-min-h-[18px] tw-border tw-border-[#7B7575] tw-rounded"
                                [(ngModel)]="draft.selected"
                                (input)="toggleSelection(draft)"
                            />
                            <!-- Steps Block -->
                            <div class="tw-flex tw-flex-col tw-gap-3">
                                <span
                                    class="tw-font-semibold tw-text-base tw-text-[#000000CC]"
                                >
                                    {{
                                        draft.productName
                                            ? draft.productName
                                            : ("DRAFT.GET_PRODUCT_RECCOMENDATIONS"
                                              | translate)
                                    }}
                                </span>
                                <div
                                    class="tw-text-sm tw-text-black tw-font-normal"
                                >
                                    <span
                                        [innerHTML]="
                                            formatDate(draft.updatedDateTime)
                                        "
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div
                            class="tw-flex tw-w-full tw-justify-end tw-items-start"
                        >
                            <button
                                class="tw-text-sm tw-font-semibold tw-px-4 tw-py-1.5 tw-rounded-full hover:tw-bg-blue-200"
                                type="submit"
                                [disabled]="draft.selected"
                                [ngClass]="{
                                    'tw-text-gray-600  tw-bg-gray-200':
                                        draft.selected,
                                    'tw-bg-[#DDEEF6] tw-text-[#4B6EEC] ':
                                        !draft.selected
                                }"
                                (click)="
                                    resume(
                                        draft.caseId,
                                        draft.qType,
                                        draft.selectedProducts,
                                        draft.productName
                                    )
                                "
                            >
                                {{ "COMMON.RESUME" | translate }}
                            </button>
                        </div>
                    </div>

                    <div
                        class="tw-w-full tw-bg-gray-50 tw-rounded-lg tw-px-4 tw-py-3"
                    >
                        <div
                            class="tw-text-[13px] tw-text-[#00000080] tw-font-semibold tw-mb-2"
                        >
                            {{ "DRAFT.LAST_COMPLETED" | translate }}:
                            {{ "DRAFT.STEP" | translate }}
                            {{
                                getStepNo(draft.qType) > 2
                                    ? getStepNo(draft.qType) - 1
                                    : getStepNo(draft.qType)
                            }}
                        </div>
                        <hr />
                        <ng-container *ngIf="draft.qType as currentQType">
                            <ng-container
                                *ngIf="getStepNo(currentQType) as currentStepNo"
                            >
                                <div
                                    class="tw-flex tw-flex-col tw-gap-2 tw-mt-3"
                                >
                                    <ng-container
                                        *ngFor="
                                            let step of steps;
                                            let last = last
                                        "
                                    >
                                        <!-- Step Block -->
                                        <div
                                            class="tw-flex tw-items-center tw-gap-2"
                                        >
                                            <div
                                                class="tw-flex tw-items-center md:tw-items-start tw-gap-7"
                                            >
                                                <span
                                                    class="tw-text-[12px] tw-font-medium tw-mb-1"
                                                    [ngClass]="{
                                                        'tw-text-[#000000CC]':
                                                            step.number <=
                                                            currentStepNo,
                                                        'tw-text-[#7B757566]':
                                                            step.number >
                                                            currentStepNo
                                                    }"
                                                >
                                                    {{
                                                        "DRAFT.STEP" | translate
                                                    }}
                                                    {{ step.number }}
                                                </span>
                                                <div
                                                    class="tw-flex tw-gap-[2px]"
                                                >
                                                    <mat-icon
                                                        class="tw-text-[18px] tw-h-[18px] tw-w-[18px]"
                                                        [ngClass]="{
                                                            'tw-text-[#4B6EEC]':
                                                                step.number <=
                                                                currentStepNo,
                                                            'tw-text-[#FF5757]':
                                                                step.number >
                                                                currentStepNo
                                                        }"
                                                    >
                                                        {{
                                                            step.number <=
                                                            currentStepNo
                                                                ? "check_circle_outline"
                                                                : "error_outline"
                                                        }}
                                                    </mat-icon>
                                                    <span
                                                        class="tw-text-sm tw-font-semibold"
                                                        [ngClass]="{
                                                            'tw-text-[#4B6EEC]':
                                                                step.number <=
                                                                currentStepNo,
                                                            'tw-text-[#000000CC]':
                                                                step.number >
                                                                currentStepNo
                                                        }"
                                                    >
                                                        {{
                                                            step.label
                                                                | translate
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Arrow (skip for last step) -->
                                        <span
                                            *ngIf="!last"
                                            class="tw-text-gray-400"
                                        >
                                            <svg
                                                width="13"
                                                height="7"
                                                viewBox="0 0 13 7"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M11.5 1L6.5 6L1.5 1"
                                                    stroke="black"
                                                    stroke-opacity="0.8"
                                                    stroke-width="2"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>

                                            <!-- <mat-icon class="mat-icon tw-scale-[0.8] tw-text-caption-gray">
            keyboard_arrow_down
          </mat-icon> -->
                                        </span>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <div
        class="tw-absolute tw-top-5 md:tw-top-[300px] tw-left-0 tw-flex tw-justify-center tw-w-full"
        *ngIf="deleteDraftMsg"
    >
        <div
            class="md:tw-flex md:tw-items-center tw-px-8 tw-py-5 tw-rounded-2xl md:tw-rounded-full md:tw-text-center tw-z-50 tw-bg-[#E0F4FF] tw-text-sm md:tw-text-base tw-text-primary-blue tw-font-semibold"
        >
            <div class="tw-hidden md:tw-block">
                <mat-icon class="tw-me-3 mat-icon">check</mat-icon>
            </div>
            <div
                class="tw-text-[10px] tw-opacity-30 tw-text-primary-blue-dark tw-font-medium tw-pb-2 tw-block md:tw-hidden"
            >
                Successful
            </div>
            {{ "DRAFT.DRAFT_DELETE" | translate }}
        </div>
    </div>
</div>
<app-loader [showLoader]="!apiResponse"></app-loader>
